import React, { FC } from 'react';
import {
    Text,
    Box,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalSize,
    ButtonAppearance,
    Button,
    ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { DeleteDocumentErrorProps } from './types';
import { DeleteCommodityAttachmentError, DeleteWorkPackageAttachmentError } from '@bechtel/types';

const getErrorMessage = (error: DeleteDocumentErrorProps['error']) => {
    if (error instanceof ApolloError) {
        return <Trans>Network error has occured.Please close button and try again.</Trans>;
    }
    switch (error) {
        case DeleteCommodityAttachmentError.ASSOCIATED_ATTACHMENT_NOT_AVAILABLE:
        case DeleteWorkPackageAttachmentError.ASSOCIATED_ATTACHMENT_NOT_AVAILABLE:
            return <Trans>Associated attachment not available.</Trans>;
        case DeleteCommodityAttachmentError.DELETE_COMMODITY_ATTACHMENT_ERRORED:
            return <Trans>Commodity attachement error.</Trans>;
        case DeleteWorkPackageAttachmentError.DELETE_WORK_PACKAGE_ATTACHMENT_ERRORED:
            return <Trans>Work package attachement error.</Trans>;
        default:
            return <Trans>An error has occured for the document. Please click close button and try again.</Trans>;
    }
}

export const DeleteDocumentError: FC<DeleteDocumentErrorProps> = ({ error, onClose }) => {
    return (
        <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
            <ModalHeader title={t`Delete Document Error`}>
                <ModalClose onClick={close}></ModalClose>
            </ModalHeader>
            <ModalBody>
                <Box p={{ sm: '500' }}>
                    <Text size="500">{getErrorMessage(error)}</Text>
                </Box>
            </ModalBody>
            <ModalFooter>
                <Box justifyContent={{ sm: 'flex-end' }}>
                    <Box mr={{ sm: '400' }}>
                        <Button appearance={ButtonAppearance.SECONDARY} onClick={onClose}>
                            <Trans> Close</Trans>
                        </Button>
                    </Box>
                </Box>
            </ModalFooter>
        </Modal>
    );
};
